module.exports = __webpack_public_path__ + "img/seats.b078d125.png";